<template>
    <div class="ethnicity-container">
        <div class="card-container" v-if="Status.LoadingCompleted">
            <!-- 分析文字 -->
            <div class="section-block">
                <p v-if="analysisText" v-html="analysisText"></p>
            </div>

            <!-- 详情表格 -->
            <div class="section-block">
                <div class="section-header">
                    <h3 class="section-title">民族分析详情</h3>
                    <el-button type="success" size="small" icon="el-icon-download" @click="handleExport">导出</el-button>
                </div>
                <div class="data-table-wrapper">
                    <div class="data-table-body">
                        <el-table :data="tableData" border :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '600'}">
                            <el-table-column type="index" label="序号" min-width="60" align="center"></el-table-column>
                            <el-table-column prop="College" label="学院" min-width="150" align="center" :filters="collegeFilters" :filter-method="filterCollege"></el-table-column>
                            <el-table-column prop="MajorName" label="专业" min-width="200" align="center"></el-table-column>
                            <el-table-column prop="TotalCount" label="总计" min-width="100" align="center"></el-table-column>
                            
                            <!-- 动态列出所有民族 -->
                            <el-table-column v-for="ethnicity in ethnicities" :key="ethnicity" :label="ethnicity" align="center">
                                <el-table-column :label="'人数'" min-width="80" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row['Ethnicity_' + ethnicity + '_Count'] || 0 }}
                                    </template>
                                </el-table-column>
                                <el-table-column :label="'比例'" min-width="80" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row['Ethnicity_' + ethnicity + '_Ratio'] ? scope.row['Ethnicity_' + ethnicity + '_Ratio'].toFixed(2) + '%' : '-' }}
                                    </template>
                                </el-table-column>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { TYBM_Env } from '../../env.js';
import { TYBM_Tools } from '../../tools.js';

export default {
    name: 'EthnicityAnalysis',
    inject: ['Loading', 'LoadingCompleted'],
    data() {
        return {
            Status: {
                LoadingCompleted: false
            },
            tableData: [],
            ethnicities: [],
            analysisText: '',
            year: 0,
            totalCount: 0,
            collegeFilters: []
        };
    },
    methods: {
        loadData() {
            const that = this;

            const api_name = '/Analysis/GetEthnicityData';
            const url = TYBM_Env.GetApiUrl(api_name);

            TYBM_Tools.AxiosGetEx(that, api_name, url, { loading_msg: '正在加载数据' })
                .then(result => {
                    that.tableData = result.data.StatList;
                    that.ethnicities = result.data.Ethnicities;
                    that.totalCount = result.data.TotalCount;
                    that.year = result.data.Year;

                    that.collegeFilters = [...new Set(that.tableData.map(item => item.College).filter(c => c))].map(c => ({ text: c, value: c }));

                    that.generateAnalysisText();
                    that.Status.LoadingCompleted = true;
                })
                .catch(() => {
                    that.$message.error('加载数据失败');
                });
        },
        generateAnalysisText() {
            const that = this;
            if (!that.ethnicities || that.ethnicities.length === 0) {
                that.analysisText = '';
                return;
            }

            // 统计各民族总数
            const ethnicityCounts = {};
            that.ethnicities.forEach(ethnicity => {
                ethnicityCounts[ethnicity] = 0;
            });
            
            that.tableData.forEach(row => {
                that.ethnicities.forEach(ethnicity => {
                    ethnicityCounts[ethnicity] += row['Ethnicity_' + ethnicity + '_Count'] || 0;
                });
            });

            // 按人数排序，取前5
            const sortedEthnicities = Object.keys(ethnicityCounts).sort((a, b) => ethnicityCounts[b] - ethnicityCounts[a]);
            const top5 = sortedEthnicities.slice(0, Math.min(5, sortedEthnicities.length));
            const top5Texts = top5.map(ethnicity => {
                const count = ethnicityCounts[ethnicity];
                const ratio = that.totalCount > 0 ? (count / that.totalCount * 100).toFixed(2) : 0;
                return `${ethnicity}(${count}人，${ratio}%)`;
            }).join('、');

            that.analysisText = `${that.year}年共录取${that.totalCount}人 ，录取前5的民族为${top5Texts}。`;
        },
        filterCollege(value, row) {
            return row.College === value;
        },
        handleExport() {
            const that = this;
            if (that.tableData.length === 0) {
                that.$message.warning('没有数据可导出');
                return;
            }

            let csvContent = "\uFEFF";
            const headers = ["序号", "学院", "专业", "总计"];
            that.ethnicities.forEach(ethnicity => {
                headers.push(ethnicity + '-人数');
                headers.push(ethnicity + '-比例');
            });
            csvContent += headers.join(",") + "\n";

            that.tableData.forEach((row, index) => {
                const rowData = [
                    index + 1,
                    row.College || '-',
                    row.MajorName,
                    row.TotalCount
                ];
                that.ethnicities.forEach(ethnicity => {
                    rowData.push(row['Ethnicity_' + ethnicity + '_Count'] || 0);
                    rowData.push(row['Ethnicity_' + ethnicity + '_Ratio'] ? row['Ethnicity_' + ethnicity + '_Ratio'].toFixed(2) + '%' : '-');
                });
                csvContent += rowData.join(",") + "\n";
            });

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", `民族分析详情_${that.year}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    },
    created() {
        this.loadData();
    },
    mounted() {
        this.$root.$on('global-year-change', this.loadData);
    },
    beforeDestroy() {
        this.$root.$off('global-year-change', this.loadData);
    }
};
</script>

<style scoped>
.ethnicity-container {
    width: 100%;
}

.section-block {
    margin-bottom: 0px;
    background: white;
    border-radius: 8px;
    padding: 5px;
}

.section-title {
    margin: 0 0 12px 0;
    color: #303133;
    font-size: 16px;
    font-weight: 600;
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
}

.data-table-wrapper {
    background: white;
    border-radius: 8px;
    overflow-x: auto;
    overflow-y: auto;
    max-height: calc(100vh - 520px);
}

.data-table-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.data-table-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 5px;
}

.data-table-wrapper::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 5px;
}

.data-table-wrapper::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.data-table-body {
    width: max-content;
    min-width: 100%;
}

.data-table-body >>> .el-table {
    font-size: 13px;
}

.data-table-body >>> .el-table th,
.data-table-body >>> .el-table td {
    padding: 8px 0 !important;
}

.data-table-body >>> .el-table th {
    background-color: #f5f7fa !important;
    color: #606266;
    font-weight: 600;
}

.data-table-body >>> .el-table__row:hover {
    background-color: #f5f9ff;
}

.data-table-body >>> .el-table .cell {
    padding: 0 8px;
}
</style>

